import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "setup";
import { acquireSubmissionLock, releaseSubmissionLock } from "../shared/lockThunks";

// Edit-lock session for the submission open in the wizard. "denied" means another user holds a
// live lock — the wizard page redirects back to the landing page on it.

type SubmissionLockState = {
  LockStatus: "idle" | "acquiring" | "held" | "denied";
  HeldByUserName?: string;
};

const initialState: SubmissionLockState = {
  LockStatus: "idle",
};

export const submissionLockSlice = createSlice({
  name: "dataImportSubmissionLock",
  initialState,
  reducers: {
    clearSubmissionLock: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(acquireSubmissionLock.pending, (state) => {
        state.LockStatus = "acquiring";
        state.HeldByUserName = undefined;
      })
      .addCase(acquireSubmissionLock.fulfilled, (state, action) => {
        state.LockStatus = action.payload.heldByCurrentUser ? "held" : "denied";
        state.HeldByUserName = action.payload.heldByUserName;
      })
      .addCase(acquireSubmissionLock.rejected, (state) => {
        state.LockStatus = "denied";
      })
      .addCase(releaseSubmissionLock.fulfilled, () => initialState);
  },
});

export const { clearSubmissionLock } = submissionLockSlice.actions;

export const selectSubmissionLockStatus = (state: RootState) => state.dataImportSubmissionLock.LockStatus;
export const selectSubmissionLockDenied = (state: RootState) => state.dataImportSubmissionLock.LockStatus === "denied";
export const selectSubmissionLockHeldByUserName = (state: RootState) => state.dataImportSubmissionLock.HeldByUserName;

export default submissionLockSlice.reducer;
